<!-- Agreements attached to Promos -->
<template>
  <div>
    <div class="text-center">
      <vx-tooltip
        :text="'View Attached Agreements'"
        position="bottom"
        class="inline-flex">
        <span class="cursor-pointer" @click="viewAgreements">
          <u> View </u>
        </span>
      </vx-tooltip>
    </div>

    <!-- Agreement List Popup Start -->
    <vs-popup
      class="agreements-popup"
      title="View Agreements"
      :active.sync="attachedAgreementsPopupActive">
      <div
        id="agrementsDiv-with-loading"
        class="div-with-modal-loading vs-con-loading__container">
        <div>
          <!-- <vs-collapse>
            <vs-collapse-item open> -->
          <div class="static-box-header">
            <div class="header">ATTACHED AGREEMENTS</div>
            <div class="form-actions">
              <vx-tooltip text="Delete" position="top">
                <vs-button
                  class="iconOnly"
                  color="dark"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  @click="removeAgreement"
                ></vs-button>
              </vx-tooltip>
            </div>
          </div>

          <div v-if="agreements.length > 0">
            <div class="agreement-details-form table-form">
              <ul class="table-head">
                <li class="theading"></li>
                <li class="theading">Name</li>
                <li class="theading">Uploaded On</li>
              </ul>
              <div
                v-for="(agt, counter) in agreements"
                v-bind:key="counter"
                class="relative">
                <ul class="agtDetail-repeater table-body">
                  <li>
                    <vs-checkbox v-model="agt.checkbox"></vs-checkbox>
                  </li>
                  <li>
                    <div class="table-form-component">
                      <a :href="agt.dropbox_link" target="blank">
                        <vs-input
                          :name="`name-${counter}`"
                          class="w-full"
                          :disabled="true"
                          v-model="agt.filename" />
                      </a>
                    </div>
                  </li>
                  <li>
                    <div class="table-form-component">
                      <flat-pickr
                        class="w-full"
                        :disabled="true"
                        v-model="agt.created_at" />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div v-else>
            <div class="no-agts-found text-center">No Agreements Found</div>
          </div>
          <!-- </vs-collapse-item>
          </vs-collapse> -->
        </div>

        <!-- TODO: When Tucows is done, get this sorted -->
        <!-- <div class="vx-row flex mb-10 justify-end">
          <div class="vx-col w-1/3 upload-agt-btn mt-12">
            <vs-button
              id="button-with-loading"
              color="primary"
              class="ml-auto float-right"
              @click="selectNewAgreement"
              icon-after
              >Select Agreement</vs-button>
          </div>
          <div class="vx-col w-1/7 upload-agt-btn mt-12">
            <vs-button
              id="button-with-loading"
              color="primary"
              type="filled"
              class="ml-auto"
              @click="saveAgreements"
              icon-after
              >Save Changes</vs-button>
          </div>
        </div> -->
      </div>
    </vs-popup>
    <!-- Agreement List Popup End -->

    <!-- Select Agreement Popup Start -->
    <SelectAgreementComponent
      v-if="registrar"
      :registrar="registrar"
      :reseller="reseller"
      :edit="true"
      ref="selectAgtComponent"
    ></SelectAgreementComponent>
    <!-- Select Agreement Popup End -->
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import SelectAgreementComponent from "@/components/ag-grid-tables/promos/SelectAgreementComponent.vue";

export default {
  name: "CellRendererAgreementList",
  components: {
    flatPickr,
    SelectAgreementComponent,
  },
  data() {
    return {
      rowData: {},
      agreements: [],
      registrar: [],
      reseller: [],
      counter: [],
      source: null,
      promo_id: null,
      attachedAgreementsPopupActive: false,
    };
  },
  watch: {
    agreements: {
      deep: true,
      immediate: true,
      handler() {
        this.updateCounter();
      },
    },
  },
  methods: {
    updateCounter: function () {
      this.counter = [];
      this.agreements.forEach((element, index) => {
        if (element.checkbox == true) {
          var count = index;
          this.counter.push(count);
        }
      });

      return this.counter;
    },
    viewAgreements: function () {
      Object.assign(this.rowData, this.params);

      this.attachedAgreementsPopupActive = true;
      if (this.rowData.editPendingReq) {
        this.promo_id = this.rowData.data.promo_id;
      } else {
        this.promo_id = this.rowData.data.id;
      }
      this.agreements = this.rowData.value;
      if (this.agreements && this.agreements.length) {
        this.agreements.map((x, index) => {
          x["counter"] = index;
          x["checkbox"] = false;
          return x;
        });
      }

      this.source = this.rowData.source;
    },
    removeAgreement: function () {
      this.agreements = this.agreements.filter(
        (el) => this.updateCounter().indexOf(el.counter) == -1
      );
    },
    selectNewAgreement: function () {
      let registrar = this.rowData.data.new_registrar;
      let reseller = this.rowData.data.new_reseller;

      if (reseller) {
        this.reseller = [
          {
            label: reseller.name,
            value: reseller.id,
          },
        ];
      } else {
        this.registrar = [
          {
            label: registrar.unique_registrar.name,
            value: registrar.id,
            unique_registrar_id: registrar.unique_registrar.id
          },
        ];
      }
      this.$refs.selectAgtComponent.openSelectAgtPopup();
    },
    saveAgreements: function () {
      let payload = this.formPayload();
      this.$axiosSecure
        .post(`/agreements/edit/${this.promo_id}`, payload, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.data.type == "Success") {
            this.$vs.dialog({
              color: "success",
              title: "Success",
              text: response.data.message,
              acceptText: "Close",
              accept: () => {},
            });
          } else if (response.data.type == "Error") {
            this.$vs.dialog({
              color: "danger",
              title: "Error",
              text: response.data.message,
              acceptText: "Close",
              accept: () => {},
            });
          }
        })
        .catch((error) => {
          console.log("error", error);
          setTimeout(() => {
            this.$vs.dialog({
              color: "danger",
              title: "Error",
              text: "Error occured while editing the attached agreements, Please try again.",
              acceptText: "Close",
              accept: () => {},
            });
          }, 200);
        })
        .finally(() => {
          this.attachedAgreementsPopupActive = false;
          this.$root.$emit("tableRefresh");
        });
    },
    formPayload() {
      let idArr = this.agreements.map((x) => x.id);
      return {
        id: idArr,
        type: this.source,
      };
    },
  },
  mounted() {
    this.$root.$on("selectedAgtsForEdit", (agtsData) => {
      this.agreements = this.agreements.concat(agtsData);

      let idArr = this.agreements.map((el) => el.id);

      // Remove duplicates
      this.agreements = this.agreements.filter(
        (x, index) => idArr.indexOf(x.id) == index
      );

      if (this.agreements && this.agreements.length) {
        this.agreements.map((x, index) => {
          x["counter"] = index;
          x["checkbox"] = false;
          return x;
        });
      }
    });
  },
  destroyed() {
    this.$root.$off("selectedAgtsForEdit");
  },
};
</script>
<style lang="scss">
.disabled {
  pointer-events: none;
  opacity: 0.4;
}

.con-vs-popup.agreements-popup {
  // z-index: 54000;

  ~ .vs__dropdown-menu {
    z-index: 99990 !important;
    max-height: 200px !important;
  }
  .vs-popup {
    width: 75%;
    height: 100%;
    margin-top: 8rem;
  }
  .vs-popup--header {
    background: transparent;
  }
  .vs-popup--title h3 {
    letter-spacing: -1.05px;
    font-size: 20px;
    line-height: 25px;
    font-family: "Work Sans", sans-serif;
    color: #000000;
    font-weight: 600;
  }
  .vs-popup--content {
    padding: 1rem 2rem;
    label {
      color: #000;
      font-size: 12px;
      line-height: 18px;
      font-family: "Work Sans", sans-serif;
      letter-spacing: -0.36px;
      font-weight: 500;
    }
  }
  .close-btn.includeIconOnly {
    width: 18px !important;
    height: 18px !important;
  }
  .form-field.agt-name-field {
    width: 400px !important;
  }
  .vs-collapse-item {
    .vs-collapse-item--header {
      line-height: 18px;
      padding-top: 0.7rem;
      padding-bottom: 0.7rem;
    }
    .form-actions {
      height: 37px;
    }
    &.open-item .vs-collapse-item--content {
      max-height: initial !important;
    }
  }
  .agreement-details-form.table-form {
    .table-head,
    .table-body {
      > li {
        width: 50%;
        &:nth-child(1) {
          width: 10%;
        }
        &:nth-child(6) {
          width: 15%;
        }
      }
    }

    input:disabled {
      color: #626262 !important;
      opacity: 1;
      background: transparent;
    }

    .inputPrefix {
      .currency-sign {
        width: 50px;
      }
      .vs-con-input input {
        padding-left: 3.4rem !important;
      }
    }
  }
  .upload-agt-btn {
    align-items: center;
    display: flex;
    margin-top: 20px;
  }
}

.table-form-component {
  a {
    text-decoration: underline;
  }
}

.no-agts-found {
  font-size: 1rem;
  border-right: 1px solid #f5f5f5;
  border-left: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;
  padding: 0.78rem;
}
</style>